<template lang="pug">
  .qmod-modal-content
    div.qmod-modal-list-wrap
      ul.qmod-list
        li.qmod-list-item(v-for="item in events", @click="toggleEvent(item)")
          span.qmod-list-text {{item.event}}
          ToggleButton(:enabled="item.isEnabled")

</template>

<script>
import ToggleButton from "@LAYOUT/ToggleButton"

export default {
  name: "Events",
  components: {
    ToggleButton
  },
  props: ["enabled", "events"],
  data() {
    return {
      title: "Events",
      isEnabled: this.enabled
    }
  },
  methods: {
    toggleEvent(item) {
      item.isEnabled = !item.isEnabled
      this.$emit("toggleEvent", item)
    }
  },
  computed: {
    getEnabled() {
      return this.isEnabled ? "On" : "Off"
    }
  },
  mounted() {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus">
</style>
